module.exports = __webpack_public_path__ + "img/DNADamage-PDAC_GSE202740.831d8499.png";